
import EditBase from "../EditBase"

class EditEllipsoid extends EditBase{

    constructor(options) {
        super(options);
    }

    checkRotatePoint() {
        return false;
    }

    checkHeightPoint() {
        return false;
    }

    initKeyPoint(){
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var e_pos = [];
        for (let i = 1; i < keyPos.length; i++) {
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Nor"));
            entity.show = false;
            entity.position = keyPos[i];
            entity.point = point;
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            entity.attrPlot = {
                e_index: i,
                editGuid: this.editGuid,
                edit_keyFlag: true
            };
            e_pos.push(entity);
        }
        this.plot.attrPlot["edit_keyPos"] = e_pos; //实体
    }

    initCenterPoint(){
        var cartesian3=this.plot.attrPlot["edit_positions"][0];
        var entity = this.createEnity();
        var point = this.createPoint(this.getDefaultStyle("point_Center"));
        entity.show = false;
        entity.position = cartesian3;
        entity.point = point;
        entity.attrPlot = {
            editGuid: this.editGuid,
            edit_centerFlag: true
        };
        this.viewer.entities.add(entity);
        this.entities.push(entity);
        this.plot.attrPlot["edit_center"] = entity; //实体
        this.plot.attrPlot['center_cartesian3'] = cartesian3;
    }

    updateCenter(){

    }
    translateAll(position){
        super.translateAll(position);
        this.plot.position.setValue(position);
    }

    initProperty() {
        var $this = this;
        var minR = 1;
        var positions = [];
        var rProperty = new $this.Cesium.CallbackProperty(function () {
            positions = $this.plot.attrPlot["edit_positions"];
            var center = positions[0];
            var outline = positions[1];

            var r= Cesium.Cartesian3.distance(center, outline);
            r = r ? r : r + minR;
            return new Cesium.Cartesian3(r, r, r);
        }, false);

        this.plot.ellipsoid.radii = rProperty;
    }



}


export default EditEllipsoid
